/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { ReAcceptConsentsRequestDto } from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class UserConsentControllerV2<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags user-consent-controller-v-2
   * @name ReAccept
   * @request POST:/api/v2/terms-and-conditions/re-accept
   */
  reAccept = (data: ReAcceptConsentsRequestDto, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v2/terms-and-conditions/re-accept`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static reAcceptPath = '/v2/terms-and-conditions/re-accept'
  static reAcceptMethod = 'POST'
  /**
   * No description
   *
   * @tags user-consent-controller-v-2
   * @name ReAcceptAuthorized
   * @request POST:/api/v2/terms-and-conditions/re-accept/authorized
   */
  reAcceptAuthorized = (data: ReAcceptConsentsRequestDto, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v2/terms-and-conditions/re-accept/authorized`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static reAcceptAuthorizedPath = '/v2/terms-and-conditions/re-accept/authorized'
  static reAcceptAuthorizedMethod = 'POST'
}
